<template>
  <div class="select-wrap">
    <ul>
      <li v-for="(item, index) in cardList" :key="index" @click.prevent="selectCard(item)">
        <div class="img-box save-item-line" v-if="item.imageUrl && (item.status === 'EXPIRATION' || item.status === 'DISCARD')">
          <img :src=item.imageUrl :alt="item.imageDesc" class="image-filter"/>
          <span class="save-item-text">만료</span>
        </div>
        <div class="img-box" v-if="item.imageUrl && item.status != 'EXPIRATION' && item.status != 'DISCARD'">
          <img :src=item.imageUrl :alt="item.imageDesc">
        </div>
        <div class="text-box">
          <span v-if="item.prepaidCardNo">{{item.prepaidCardNickName}} <br/> {{$store.state.isMberPwdAuthenticated ? '('+ item.prepaidCardNo +')' : ''}}</span>
          <span v-else>{{item.prepaidCardNickName}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'OrderSelect',
  props: ["cardList"],
  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {
    async selectCard(prepaidCardNo) {
      this.$emit("select-card", prepaidCardNo);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common/orderSelect.scss";
.save-item-line { position: relative;}
.save-item-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  @include font-size(rem(12), rem(20), 700);
  @include font-roboto;
  color: $color-white;
}
</style>
